/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiResultOfJsonApiEventParty,
    ApiResultOfJsonApiEventPartyFromJSON,
    ApiResultOfJsonApiEventPartyToJSON,
    ApiResultOfJsonApiLog,
    ApiResultOfJsonApiLogFromJSON,
    ApiResultOfJsonApiLogToJSON,
    JsonApiLog,
    JsonApiLogFromJSON,
    JsonApiLogToJSON,
} from '../models';

export interface GetEventPartyByBarcodeUsingGETRequest {
    barcode: string;
    token?: string;
    type?: string;
    readerId?: string;
    placeId?: number;
    dateTime?: string;
    service?: string;
    testOnly?: boolean;
}

export interface UpdateApiLogUsingPOSTRequest {
    json: JsonApiLog;
    testOnly?: boolean;
}

/**
 * 
 */
export class ApiControllerApi extends runtime.BaseAPI {

    /**
     * getEventPartyByBarcode
     */
    async getEventPartyByBarcodeUsingGETRaw(requestParameters: GetEventPartyByBarcodeUsingGETRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiResultOfJsonApiEventParty>> {
        if (requestParameters.barcode === null || requestParameters.barcode === undefined) {
            throw new runtime.RequiredError('barcode','Required parameter requestParameters.barcode was null or undefined when calling getEventPartyByBarcodeUsingGET.');
        }

        const queryParameters: any = {};

        if (requestParameters.token !== undefined) {
            queryParameters['token'] = requestParameters.token;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        if (requestParameters.readerId !== undefined) {
            queryParameters['readerId'] = requestParameters.readerId;
        }

        if (requestParameters.placeId !== undefined) {
            queryParameters['placeId'] = requestParameters.placeId;
        }

        if (requestParameters.dateTime !== undefined) {
            queryParameters['dateTime'] = requestParameters.dateTime;
        }

        if (requestParameters.service !== undefined) {
            queryParameters['service'] = requestParameters.service;
        }

        if (requestParameters.testOnly !== undefined) {
            queryParameters['testOnly'] = requestParameters.testOnly;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/rest-service/api/event-party/{barcode}`.replace(`{${"barcode"}}`, encodeURIComponent(String(requestParameters.barcode))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResultOfJsonApiEventPartyFromJSON(jsonValue));
    }

    /**
     * getEventPartyByBarcode
     */
    async getEventPartyByBarcodeUsingGET(requestParameters: GetEventPartyByBarcodeUsingGETRequest, initOverrides?: RequestInit): Promise<ApiResultOfJsonApiEventParty> {
        const response = await this.getEventPartyByBarcodeUsingGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * updateApiLog
     */
    async updateApiLogUsingPOSTRaw(requestParameters: UpdateApiLogUsingPOSTRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ApiResultOfJsonApiLog>> {
        if (requestParameters.json === null || requestParameters.json === undefined) {
            throw new runtime.RequiredError('json','Required parameter requestParameters.json was null or undefined when calling updateApiLogUsingPOST.');
        }

        const queryParameters: any = {};

        if (requestParameters.testOnly !== undefined) {
            queryParameters['testOnly'] = requestParameters.testOnly;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/rest-service/api/event-party`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JsonApiLogToJSON(requestParameters.json),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResultOfJsonApiLogFromJSON(jsonValue));
    }

    /**
     * updateApiLog
     */
    async updateApiLogUsingPOST(requestParameters: UpdateApiLogUsingPOSTRequest, initOverrides?: RequestInit): Promise<ApiResultOfJsonApiLog> {
        const response = await this.updateApiLogUsingPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
